import { render } from "./VTStatistica.vue?vue&type=template&id=e79c164a&scoped=true"
import script from "./VTStatistica.vue?vue&type=script&lang=js"
export * from "./VTStatistica.vue?vue&type=script&lang=js"

import "./VTStatistica.vue?vue&type=style&index=0&id=e79c164a&scoped=true&lang=css"

import exportComponent from "/Users/emmanueledurante/Documents/Lavoro/Martech/whappy-app-front-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e79c164a"]])

export default __exports__